import { createAttributeSet } from "global/Application";
import { Acronym, ArrayToLookupByPredicate } from "global/Utility/TSFunctions";
import * as FAM from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";

/**
 * 
 * Shared Savings Transformer
 * Transformer:
 * https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/412925
 */
export class Sprint21Transformer extends BaseJsonTransformer {
    config: FAM.IGroupConfigurationConfig;
    json: FAM.IGroupConfigurationData;

    constructor({ config, json }: { config: FAM.IGroupConfigurationConfig, json: FAM.IGroupConfigurationData }) {
        super();
        this.config = config;
        this.json = json;
    }

    async before(json: FAM.IGroupConfigurationData): Promise<void> {
        console.debug("[tran] Sprint21Transformer.before")
    }

    async transformAccountsReceivable(accountsReceivable: FAM.IAccountsReceivable): Promise<boolean | void> {

    }

    async transformFeesAndPremium(feesAndPremium: FAM.IFeesAndPremiums): Promise<boolean | void> {

        const feesAndPremiumFieldMap = ArrayToLookupByPredicate(feesAndPremium.fields, (t) => {
            return t.configRef.id
        });

        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=eeeab0ef-e778-ec11-8d21-000d3a35957e
        const bcbs_PPO_Percent = feesAndPremiumFieldMap["eeeab0ef-e778-ec11-8d21-000d3a35957e"];

        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=f6eab0ef-e778-ec11-8d21-000d3a35957e
        const bcbs_PPO_Cap = feesAndPremiumFieldMap["f6eab0ef-e778-ec11-8d21-000d3a35957e"];

        //https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=f0eab0ef-e778-ec11-8d21-000d3a35957e
        const bcbs_ParTrad_Percent = feesAndPremiumFieldMap["f0eab0ef-e778-ec11-8d21-000d3a35957e"];

        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=eceab0ef-e778-ec11-8d21-000d3a35957e
        const bcbs_ParTrad_Cap = feesAndPremiumFieldMap["eceab0ef-e778-ec11-8d21-000d3a35957e"];

        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=f2eab0ef-e778-ec11-8d21-000d3a35957e
        const bcbs_OON_Percent = feesAndPremiumFieldMap["f2eab0ef-e778-ec11-8d21-000d3a35957e"];

        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=f4eab0ef-e778-ec11-8d21-000d3a35957e
        const bcbs_OON_Cap = feesAndPremiumFieldMap["f4eab0ef-e778-ec11-8d21-000d3a35957e"];

        const bcbs_sharedsavings = feesAndPremiumFieldMap["3cff3342-585e-ee11-be70-6045bd0a8edc"];

        const sharedSavings_config_attribute = this.config.cache.map_bcbs_config_attribute[bcbs_sharedsavings.configRef.id];
        const sharedSavings_config_masterattribute = this.config.cache.map_bcbs_config_masterattribute[sharedSavings_config_attribute._bcbs_config_masterattributeid_value!];

        const addAttributeSet = (percent: number | undefined, currency: number | undefined, val: "INN" | 'OON' | 'PAR') => {

            const newAttributeSet = createAttributeSet({ config: this.config, json: this.json }, sharedSavings_config_masterattribute);
            let name = newAttributeSet.name;

            const newAttributeSetFieldMap = ArrayToLookupByPredicate(newAttributeSet.fields, (t) => {
                return t.configRef.id
            });

            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=7b606da3-585e-ee11-be6f-000d3a3bec27
            const bcbs_sharedsavings_categorycode = newAttributeSetFieldMap['7b606da3-585e-ee11-be6f-000d3a3bec27'];

            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=7d606da3-585e-ee11-be6f-000d3a3bec27
            const bcbs_sharedsavings_sspicomponentcode = newAttributeSetFieldMap['7d606da3-585e-ee11-be6f-000d3a3bec27'];

            // Bill to Group
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=85606da3-585e-ee11-be6f-000d3a3bec27
            const bcbs_sharedsavings_billtogrouppercent = newAttributeSetFieldMap['85606da3-585e-ee11-be6f-000d3a3bec27'];

            // Bill to Group ($) - (Ignore)
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=87606da3-585e-ee11-be6f-000d3a3bec27
            const bcbs_sharedsavings_billtogroupcurrency = newAttributeSetFieldMap['87606da3-585e-ee11-be6f-000d3a3bec27'];

            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=89606da3-585e-ee11-be6f-000d3a3bec27
            const bcbs_sharedsavings_captypecode = newAttributeSetFieldMap['89606da3-585e-ee11-be6f-000d3a3bec27'];

            // Cap Amount
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=8b606da3-585e-ee11-be6f-000d3a3bec27
            const bcbs_sharedsavings_capamount = newAttributeSetFieldMap['8b606da3-585e-ee11-be6f-000d3a3bec27'];

            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=8d606da3-585e-ee11-be6f-000d3a3bec27
            const bcbs_sharedsavings_partnerplanpercent = newAttributeSetFieldMap['8d606da3-585e-ee11-be6f-000d3a3bec27'];

            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=7bd0a630-3c14-ed11-b83b-000d3a372023&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=8f606da3-585e-ee11-be6f-000d3a3bec27
            const bcbs_sharedsavings_natokeeppercent = newAttributeSetFieldMap['8f606da3-585e-ee11-be6f-000d3a3bec27'];

            bcbs_sharedsavings_categorycode.values[0].value = {
                type: "entity",
                entityType: "bcbs_config_optionsetitem",
                id: "ad7e9d03-565e-ee11-be71-000d3a3be219",
                name: "Network"
            };

            if (val === 'INN') {
                name = "INN Shared Savings";
                bcbs_sharedsavings_sspicomponentcode.values[0].value = {
                    type: "entity",
                    entityType: "bcbs_config_optionsetitem",
                    id: "997e9d03-565e-ee11-be71-000d3a3be219",
                    name: name
                }
            }

            if (val === "PAR") {
                name = "OON Shared Savings - Par / Traditional";
                bcbs_sharedsavings_sspicomponentcode.values[0].value = {
                    type: "entity",
                    entityType: "bcbs_config_optionsetitem",
                    id: "20a354db-0262-ee11-be6e-000d3a58ec5d",
                    name: name,
                }
            }

            if (val === "OON") {

                name = "OON Shared Savings";
                bcbs_sharedsavings_sspicomponentcode.values[0].value = {
                    type: "entity",
                    entityType: "bcbs_config_optionsetitem",
                    id: "9b7e9d03-565e-ee11-be71-000d3a3be219",
                    name: name,
                }
            }

            delete bcbs_sharedsavings_sspicomponentcode.visibility

            bcbs_sharedsavings_captypecode.values[0].value = {
                type: "entity",
                entityType: "bcbs_config_optionsetitem",
                id: "b57e9d03-565e-ee11-be71-000d3a3be219",
                name: "PEPM",
            };

            if (percent !== undefined)
                bcbs_sharedsavings_billtogrouppercent.values[0].value = {
                    type: 'number',
                    value: percent,
                }

            if (currency !== undefined)
                bcbs_sharedsavings_capamount.values[0].value = {
                    type: 'number',
                    value: currency,
                }

            bcbs_sharedsavings_partnerplanpercent.values[0].value = {
                type: "number",
                value: 0,
            }

            bcbs_sharedsavings_natokeeppercent.values[0].value = {
                type: "number",
                value: 100,
            }

            newAttributeSet.name = `Shared Savings - ${Acronym(name)}`

            feesAndPremium.attributeSets.push(newAttributeSet)
        }

        // PPO
        {
            const percentValue = bcbs_PPO_Percent.values[0].value?.type === "number"
                ? bcbs_PPO_Percent.values[0].value.value
                : undefined

            const capValue = bcbs_PPO_Cap.values[0].value?.type === 'number'
                ? bcbs_PPO_Cap.values[0].value.value
                : undefined;

            if (percentValue || capValue)
                addAttributeSet(percentValue, capValue, 'INN');
        }

        // OON
        {
            const percentValue = bcbs_OON_Percent.values[0].value?.type === "number"
                ? bcbs_OON_Percent.values[0].value.value
                : undefined

            const capValue = bcbs_OON_Cap.values[0].value?.type === 'number'
                ? bcbs_OON_Cap.values[0].value.value
                : undefined;

            if (percentValue || capValue)
                addAttributeSet(percentValue, capValue, 'OON');
        }

        // OON-Par/Trad
        {
            const percentValue = bcbs_ParTrad_Percent.values[0].value?.type === "number"
                ? bcbs_ParTrad_Percent.values[0].value.value
                : undefined

            const capValue = bcbs_ParTrad_Cap.values[0].value?.type === 'number'
                ? bcbs_ParTrad_Cap.values[0].value.value
                : undefined;

            if (percentValue || capValue)
                addAttributeSet(percentValue, capValue, 'PAR');
        }

    }

    async after(json: FAM.IGroupConfigurationData): Promise<void> {

        console.debug("[tran] Sprint21Transformer.after")

        if (json.transformers)
            json.transformers.Sprint21 = true
    }

}
